import type { AppStrings } from './types.js';

export const ja: AppStrings = {
  // COMMON
  error_title: 'エラー',
  cancel: 'キャンセル',
  retry: 'やり直す',
  back_arrow: '← 戻る',

  // ASK SCREEN
  ask_box_unavailable: 'ボックスを利用できません',
  ask_box_unavailable_desc: 'リンクが古いか、オーナーがボックスを閉じています。',
  ask_create_own_box: '自分のボックスを作る',
  ask_sent_title: '送信しました ✅',
  ask_sent_desc: '匿名の質問がボックスオーナーに届きました。',
  ask_anonymous_hint: '質問は匿名で送られます。',
  ask_placeholder: '質問を書いてください…',
  ask_send: '送信',
  ask_sending: '送信中…',
  ask_error_rate_limit: '操作が多すぎます。1分ほど待ってから再試行してください。',
  ask_error_restart: 'Mini App を再起動してください。',
  ask_error_load: 'ボックスを読み込めませんでした。',
  ask_error_send: '質問を送信できませんでした。',
  ask_error_banned: 'このアプリでブロックされています。',
  ask_banned_appeal_btn: '申し立て',
  ask_appeal_sent: '申し立てを送信しました。手動で確認します。',

  // AGE GATE
  age_gate_title: '18歳以上限定',
  age_gate_desc:
    '匿名の質問を送ろうとしています。敬意を持って接してください：嫌がらせ、脅迫、未成年者が関与する性的コンテンツ、法律に違反するコンテンツは禁止されています。匿名だからといって免責されるわけではありません——違反は管理者に報告されます。質問を送信することで、18歳以上であること、およびルールへの同意を確認したことになります。',
  age_gate_confirm: '18歳以上です — 続ける',

  // INBOX SCREEN
  inbox_title: '質問ボックス',
  box_link_accordion: '招待リンク',
  inbox_notifications_ask: '🔔 新しい質問の通知をボットに送らせますか？',
  inbox_notifications_allow: '許可する',
  inbox_notifications_dismiss_label: '閉じる',
  inbox_box_toggle_disable: '質問を無効にする',
  inbox_box_toggle_enable: '質問を有効にする',
  inbox_box_disabled_warning: '質問は無効です — 新しい質問は受け付けられません。',
  inbox_share_hint: 'リンクを共有して、友達が匿名で質問できるようにしましょう。',
  inbox_copy: 'コピー',
  inbox_copied: 'コピーしました',
  inbox_copy_error: 'エラー',
  inbox_no_deeplink: 'リンクはデプロイ後に表示されます。',
  inbox_invite_story: 'Storyで招待',
  inbox_invite_chat: 'チャットで招待',
  inbox_card_rendering: '招待カードを生成中です。',
  inbox_story_unsupported:
    'このバージョンの Telegram では Story を利用できません。「チャットで」をお試しください。',
  inbox_story_error: 'Story を開けませんでした。',
  inbox_chat_unsupported:
    'このバージョンの Telegram ではチャット共有を利用できません。クライアントを更新してください。',
  inbox_chat_error: '共有できませんでした。もう一度お試しください。',
  inbox_chat_prepare_error: '招待の準備に失敗しました。',
  inbox_filter_incoming: '受信',
  inbox_filter_hidden: '非表示',
  inbox_filter_blocked: 'ブロック',
  inbox_filter_empty: 'まだ何もありません。',
  inbox_acc_unanswered: '未回答',
  inbox_acc_answered: '回答済み',
  inbox_acc_hidden: '非表示',
  inbox_acc_blocked: 'ブロック済み',
  inbox_empty: 'まだ質問がありません。上のリンクを共有してみましょう。',
  inbox_load_more: 'もっと読み込む',
  inbox_load_more_error: '次のページを読み込めませんでした。',
  inbox_error_load: 'ボックスを読み込めませんでした。',
  inbox_rate_limit: '操作が多すぎます。1分ほど待ってから再試行してください。',
  inbox_toggle_error: 'ボックスのステータスを変更できませんでした。',

  // MESSAGE BOX (Трек D)
  message_tagline: '匿名でメッセージを送って',
  message_placeholder: 'メッセージを書いてください…',
  message_anonymous_hint: 'メッセージは匿名で送られます。',
  message_sent_title: '送信しました ✅',
  message_sent_desc: '匿名のメッセージが届きました。',
  message_owner_entry: 'メッセージを送る',
  message_share_hint: 'リンクを共有して、誰でも匿名でメッセージを送れるようにしましょう。',
  message_inbox_open: '受信したメッセージ',
  message_inbox_title: 'メッセージ',
  message_inbox_empty: 'まだメッセージがありません。上のリンクを共有してみましょう。',

  // ANSWER SCREEN
  answer_title: '質問に回答する',
  answer_placeholder: '回答を書いてください…',
  answer_submit: '送信',
  answer_submitting: '送信中…',
  answer_back: '戻る',
  answer_error_send: '回答を送信できませんでした。',

  // SHARE SCREEN
  share_title: '回答を公開しました ✅',
  share_hint: 'カードを共有して、もっとたくさんの質問を集めましょう。',
  share_card_rendering_desc:
    'カードはまだ生成中です。質問一覧に戻って少し後でご確認ください — Story またはチャットで共有できるようになります。',
  share_card_alt: '回答カード',
  share_story_btn: 'Storyに共有',
  share_story_btn_busy: '開いています…',
  share_chat_btn: 'チャットに共有',
  share_chat_btn_busy: '準備中…',
  share_back: '質問に戻る',
  share_story_unsupported:
    'このバージョンの Telegram では Story を利用できません。「チャットに共有」をお試しください。',
  share_story_error: 'Story を開けませんでした。「チャットに共有」をお試しください。',
  share_chat_sent: 'メッセージを送りました。',
  share_chat_unsupported:
    'このバージョンの Telegram ではチャット共有を利用できません。クライアントを更新してください。',
  share_chat_error: '共有できませんでした。もう一度お試しください。',
  share_chat_prepare_error: 'メッセージの準備に失敗しました。',

  // LEADERBOARD SCREEN
  lb_title: 'ランキング',
  lb_period_7d: '7日間',
  lb_period_30d: '30日間',
  lb_period_all: '全期間',
  lb_group_label: 'カテゴリ',
  lb_group_all: 'すべて',
  lb_group_ask: '質問',
  lb_group_rate: '評価',
  lb_group_confession: '告白',
  lb_group_guesswho: '誰でしょう',
  lb_group_message: 'メッセージ',
  lb_error: 'ランキングを読み込めませんでした',
  lb_empty: 'まだランキングに誰もいません',
  lb_anon: '匿名',
  lb_load_more: 'もっと読み込む',
  lb_questions: (n) => `${n}件の質問`,
  lb_referrals: (n) => `${n}件の紹介`,

  // REWARDS SCREEN
  rw_title: '獲得報酬',
  rw_error: '報酬を読み込めませんでした',
  rw_level: (n) => `レベル ${n}`,
  rw_confirmed_referrals: (n) => `確認済み紹介 ${n}人`,
  rw_next_level_section: (n) => `次のレベル — ${n}人の紹介`,
  rw_to_level: (level, target) => `レベル ${level} まで：あと ${target}`,
  rw_max_level: '最高レベルに達しました！',
  rw_badges_section: 'バッジ',
  rw_formats_section: 'ボックスデザイン',

  // QUESTION CARD
  qcard_status_new: '新着',
  qcard_status_hidden: '非表示',
  qcard_status_answered: '回答済み',
  qcard_moderation_flagged: '注意：不審なメッセージ',
  qcard_answer_btn: '回答する',
  qcard_answer_send: '送信',
  qcard_share_btn: '共有',
  qcard_hide_btn: '非表示',
  qcard_show_btn: '表示',
  qcard_report_btn: '報告',
  qcard_block_btn: 'ブロック',
  qcard_unblock_btn: 'ブロック解除',
  qcard_report_reason_label: '報告理由を選んでください：',
  qcard_reason_spam: 'スパム',
  qcard_reason_harassment: '嫌がらせ',
  qcard_reason_sexual: '性的コンテンツ',
  qcard_reason_other: 'その他',
  qcard_error_hide: '表示設定を変更できませんでした。',
  qcard_error_report: '報告を送信できませんでした。',
  qcard_error_block: '送信者をブロックできませんでした。',
  qcard_report_done: '報告しました — ありがとうございます。',
  qcard_block_done: '送信者をブロックしました。',
  qcard_unblock_done: 'ブロックを解除しました。',

  // ERRORS
  err_network: 'サーバーに接続できません。インターネット接続を確認して再試行してください。',
  err_server_unavailable: 'サーバーが一時的に利用できません。後でもう一度お試しください。',
  err_internal: '問題が発生しました。すでに対応中です — 後でもう一度お試しください。',
  err_bad_request: '入力内容を確認してください。',
  err_generic: '操作を完了できませんでした。後でもう一度お試しください。',
  err_schema: 'データエラーが発生しました。アプリを更新してみてください。',
  share_story_link_premium_note:
    'Story のクリック可能なリンクには Telegram Premium が必要です。Premium がなくても、ユーザー名がカードに表示されるので友達は見つけられます。',

  // AUTH ERROR SCREEN
  auth_error_title: 'アクセスエラー',
  auth_error_desc:
    '認証に失敗しました。Telegram から Mini App を閉じてもう一度開いてください。',

  // REWARD TOAST
  reward_toast_title: '新しい報酬！',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: '質問',
  tab_leaderboard: 'ランキング',
  tab_rewards: '報酬',
  tab_settings: '設定',

  // SETTINGS SCREEN
  settings_title: '設定',
  settings_section_general: '一般',
  settings_notifications: '新しい質問の通知',
  settings_notifications_hint: '誰かが質問したとき、ボットがメッセージを送ります。',
  settings_notifications_error: '通知設定を保存できませんでした。',
  settings_language: '言語',
  settings_language_error: '言語を変更できませんでした。もう一度お試しください。',
  settings_section_about: 'このアプリについて',
  settings_version: 'バージョン',

  // CODE ENTRY (work-020)
  code_modal_title: 'Storyリンクは Premiumのみ',
  code_modal_explain:
    'Telegram はクリック可能な Story リンクを Premium 会員にのみ提供しています。代わりに Story にコードを追加しましょう — 訪問者がアプリでコードを入力して匿名で質問できます。',
  code_modal_your_code: 'あなたのコード',
  code_modal_copy: 'コードをコピー',
  code_modal_copied: 'コピーしました',
  code_modal_share_btn: 'Storyに共有',
  code_modal_loading: 'コードを取得中…',
  code_modal_error: 'コードを取得できませんでした。後でもう一度お試しください。',
  ask_code_title: 'コードを入力',
  ask_code_desc: 'Storyから来ましたか？Story内のコード（例：1234）を見つけて入力してください。',
  ask_code_placeholder: 'Storyのコード',
  ask_code_find: '検索',
  ask_code_not_found: 'コードが見つかりませんでした。数字を確認して再試行してください。',
  ask_code_invalid: 'コードは4桁の数字です。',
  code_onboarding_header: 'Storyから来ましたか？',
  code_onboarding_text: '友達のコードを入力して、匿名で質問を送りましょう。',
  code_onboarding_action: 'コードを入力',
  settings_ask_by_code: 'コードで質問',
  settings_my_code_title: 'Storyコード',
  settings_my_code_hint:
    'このコードを Story に書いてください — 見た人がアプリで入力して匿名で質問できます。クリック可能なリンクは Telegram Premium 会員のみが利用できます。',
  settings_my_code_rotate: '新しいコードを取得',
  settings_my_code_rotating: '更新中…',
  settings_my_code_done: 'コードを更新しました',
  settings_my_code_error: 'コードを取得できませんでした。',
  settings_my_code_rotate_confirm_title: 'コードを変更しますか？',
  settings_my_code_rotate_confirm_desc:
    '今のコードはすぐに使えなくなります。Storyでコードを見た人は、あなたに連絡できなくなります。誰かに迷惑されているときだけ変更してください。',
  settings_my_code_rotate_confirm_action: 'コードを変更',

  // BOT
  bot_greeting: (name) => (name ? `こんにちは、${name}！ 👋` : 'こんにちは！ 👋'),
  bot_onboarding:
    'これは VeylMe — 匿名の質問サービスです。\n\n' +
    'Mini App を開いて、「匿名で質問して」カードを Story に投稿しましょう — ' +
    '匿名の質問がここに届きます。\n\n' +
    '⚠️ 18+。マナーを守りましょう：いじめ、脅迫、禁止コンテンツ ' +
    'は許可されません。匿名 ≠ 免責 — 違反はモデレーションへ報告されます。',
  bot_open_btn: 'VeylMe を開く',
  notify_answer_btn: '回答する',
  bot_invite_text:
    '誰かが VeylMe のリンクをシェアしました。\n\n' +
    'Mini App を開いて匿名で質問しましょう：',
  bot_invite_btn: '匿名で質問する',

  // WORK-027 i18n sweep
  tagline: '匿名で質問して',
  share_ask_action: '質問する',
  share_answered_text: '匿名の質問に答えました 👀',
  err_not_in_telegram: 'Mini App が Telegram 内で実行されていません。アプリを再起動してください。',
  badge_viral_starter: 'バイラルスタート',
  badge_storyteller: 'ストーリーテラー',
  badge_loop_master: 'ループマスター',
  theme_confession: '告白',
  theme_guesswho: '誰でしょう',
  rw_format_named: (name) => `フォーマット「${name}」`,
  card_label_question: '質問',
  card_label_answer: '回答',
  card_invite_subtitle: '匿名、登録不要',
  card_code_hint: 'アプリでコードを入力',
  share_msg_title: (brand) => `${brand} · 匿名の質問`,
  notify_new_question: '🔔 匿名の質問が届きました',
  notify_unanswered_reminder: (n) => `🔔 未回答の質問が${n}件あります`,
  notify_ban_permanent: '永久に',
  notify_ban_until: (date) => `${date} まで`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ あなたは VeylMe で${untilPhrase}ブロックされました。多くの受信者があなたのメッセージを報告しました。\nこれが誤りだと思う場合は、アプリで異議申し立てができます。`,
  notify_warning_msg:
    '⚠️ 複数の受信者があなたのメッセージを報告しました。あと少しで VeylMe でブロックされます。',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: '自分の質問',
  my_questions_empty_title: 'まだ質問をしていません',
  my_questions_empty_desc: '誰かのボックスに質問してみよう — 返信はここに表示されます。',
  my_questions_loading: '返信を確認中…',
  my_questions_waiting: '返信待ち',
  my_questions_answer_label: '返信',
  settings_my_questions: '自分の質問',
  ask_sent_find_reply_hint: '返信は後で「自分の質問」から確認できます。',
  inbox_story_nonpremium_hint: 'Telegram Premiumがないとストーリーのリンクはタップできないため、代わりにコードを表示します — チャットでの共有がより確実です。',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegramのアクセス許可が期限切れです',
  session_expired_desc: 'Telegramはアプリへのアクセス許可を起動時に一度だけ発行します。この許可はすでに期限切れです。アプリをもう一度開いてください — 書きかけの文章は保存しました。',
  session_expired_desc_no_storage: 'Telegramのアクセス許可の期限が切れたため、アプリを開き直す必要があります。入力していた文章は保存できませんでした — 退出する前にコピーしてください。',
  session_expired_reopen: 'もう一度開く',
  session_expired_stuck_title: 'Telegramが同じ古い許可を返しました',
  session_expired_stuck_desc: 'ボットのメニューからアプリを完全に閉じて、もう一度開いてください — そうすればTelegramが新しい許可を発行します。',
  session_auth_failed_title: 'ログインを確認できませんでした',
  session_auth_failed_desc: 'Telegramがアプリへのログインを確認しませんでした。アプリを閉じて、ボットとのチャットから開き直してください。',
  session_expired_manual_close: 'ここではアプリが自分で閉じられません — ご自身で閉じて、ボットとのチャットから開き直してください。',
  session_expiring_soon: 'Telegramのアクセス許可がまもなく期限切れになります。何も失わないよう、アプリを開き直してください。',
  my_questions_check_failed: '返信を確認できませんでした。あとでもう一度お試しください。',
  settings_notifications_load_error: '設定を読み込めませんでした。',
};
